import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { LabelModule } from '@progress/kendo-angular-label';
import { ValidationErrorKeysPipe, validationMessages } from '../../pipes/validation-error-keys.pipe';

@Component({
  selector: 'shared-ui-dropdown',
  templateUrl: './shared-ui-dropdown.component.html',
  styleUrls: ['./shared-ui-dropdown.component.scss'],
  standalone: true,
  imports: [NgIf, LabelModule, FormsModule, ReactiveFormsModule, NgFor, NgbAlert, ValidationErrorKeysPipe]
})
export class SharedUiDropdownComponent {
  @Input() label = '';
  @Input() control?: FormControl
  @Input() options: any[] | null = null;
  @Input() valueName: string = '';
  @Input() displayName: string = ''
  @Input() placeholder?: string
  @Input() messages = validationMessages
}
